import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 14627 18143"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M7313 10526c-858 0-1665-333-2271-940-607-607-941-1415-941-2273V5884c0-156 126-283 284-283 155 0 282 127 282 283v1429c0 1459 1188 2646 2646 2646 1459 0 2646-1186 2646-2646V5884c0-156 127-283 284-283 156 0 283 127 283 283v1429c0 858-334 1666-941 2273s-1414 940-2272 940z"
        className="fil0"
      />
      <path
        d="M5849 12284c-157 0-284-127-284-284V9851c0-157 127-284 284-284 156 0 283 128 283 284v2149c0 157-127 284-283 284zM8778 12284c-157 0-284-127-284-284V9851c0-157 127-284 284-284s283 128 283 284l1 2149c0 157-127 284-284 284zM6471 7890c119 351 451 604 842 604s723-253 842-604H6471zm842 1172c-802 0-1455-653-1455-1455 0-157 127-284 284-284h2343c157 0 284 127 284 284 0 802-653 1455-1456 1455z"
        className="fil0"
      />
      <path
        d="M567 17575h13493v-1581c0-1213-777-2274-1934-2639l-3294-1041c-442 313-976 484-1519 484s-1076-171-1518-484l-3294 1041c-1157 365-1934 1426-1934 2639v1581zm13776 568H283c-157 0-283-127-283-284v-1865c0-714 223-1395 645-1971s1005-994 1685-1209l3433-1084c90-29 189-10 263 49 379 303 833 454 1287 454s908-151 1288-454c74-59 172-78 262-49l3433 1084c681 215 1263 633 1685 1209 423 576 646 1257 646 1971v1865c0 157-127 284-284 284z"
        className="fil0"
      />
      <path
        d="M12586 18143c-157 0-284-127-284-284 0-1297-1055-2353-2352-2353H8778c-651 0-1181 530-1181 1181 0 157-127 283-284 283s-283-126-283-283c0-651-530-1181-1181-1181H4677c-1297 0-2353 1056-2353 2353 0 157-127 284-283 284-157 0-284-127-284-284 0-780 304-1513 856-2065 551-551 1284-855 2064-855h1172c612 0 1152 316 1464 795 312-479 853-795 1465-795h1172c779 0 1513 304 2064 855 551 552 855 1285 855 2065 0 157-127 284-283 284zM4385 6167c-72 0-145-27-200-82-466-466-724-1086-724-1745 1-659 257-1278 724-1745L6341 439v-1l3-3c111-111 291-111 401 0 112 111 112 290 0 401l-6 7-2154 2153c-358 359-556 836-556 1344 0 411 130 804 371 1128l2713-2713c111-111 290-111 401 0s111 290 0 401L4585 6085c-55 55-128 83-200 82z"
        className="fil0"
      />
      <path
        d="M7345 566c-224 0-444 114-603 274-276 275-414 729-67 1076l3552 3552c550-743 488-1799-185-2472L7818 772c-146-146-311-206-473-206zm2898 5601c-75 0-148-29-201-82L6274 2316c-261-260-392-600-369-956 21-335 176-662 436-921 260-261 587-415 921-436 357-23 696 108 957 369l2224 2223c962 962 962 2528 0 3490-53 53-126 83-200 83v-1z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
